import { type ReactNode, useRef } from 'react';

import { createStore, type Store } from '../../../core/store/store.js';
import { initialState } from '../constants/chart-state.js';
import { HistogramChartStateContext } from '../contexts/HistogramChartState.context.js';
import { type HistogramChartState } from '../types/state.js';

export const StoreProvider = ({ children }: { children: ReactNode }) => {
  const storeRef = useRef<Store<HistogramChartState> | null>(null);
  const lastInteractionMode = storeRef?.current?.getState().interactionMode;

  storeRef.current = createStore({
    ...initialState,
    interactionMode: lastInteractionMode ?? initialState.interactionMode,
  });

  return (
    <HistogramChartStateContext.Provider value={storeRef.current}>
      {children}
    </HistogramChartStateContext.Provider>
  );
};

StoreProvider['displayName'] = 'StoreProvider';
